

function getSavedCar() {
    const data = localStorage.getItem('car_details');
    return data ? JSON.parse(data) : null;
}

function saveCar(brand,model){

    localStorage.setItem(

        'car_details',

        JSON.stringify({

            brand,

            model

        })

    );

}
function openCarPopup(){
     console.log("Opening Popup");

    document
        .getElementById('carPopup')
        .classList.add('show');

}

function closeCarPopup() {
    document.getElementById('carPopup').classList.remove('show');
}

// async function applyVehicle(car){

//     document.getElementById('cartCarBrand').value =
//         car.brand;

//     document.getElementById('cartCarModel').value =
//         car.model;

//     document.getElementById('cartCarSize').value =
//         car.size;

//     selectVariantBySize(car.size);

// }

async function loadModels(brand, selectedModel = ''){

        const modelSelect =
            document.getElementById('popupCarModel');

        modelSelect.innerHTML =
            '<option value="">Loading...</option>';
           
        try{
            console.log("Brand :", brand);
            console.log("URL :", `${API_BASE}/car_models?brand=${encodeURIComponent(brand)}`);
            const response =
                await fetch(
                    `${API_BASE}/car_models?brand=${encodeURIComponent(brand)}`,
                    {
                        headers:{
                            'x-api-key':API_KEY
                        }
                    }
                );

            const data =
                await response.json();

            modelSelect.innerHTML =
                '<option value="">Select Model</option>';

            data.models.forEach(model=>{

                modelSelect.innerHTML +=
                    `<option value="${model}">${model}</option>`;

            });

            if(selectedModel){

                modelSelect.value =
                    selectedModel;

                modelSelect.dispatchEvent(
                    new Event('change')
                );

            }

        }
        catch(error){

            console.error(error);

        }

}
const API_BASE =
window.vehicleConfig.apiBase;

const API_KEY =
window.vehicleConfig.apiKey;



    document.addEventListener('DOMContentLoaded', function(){
           const brandSelect = document.getElementById('popupCarBrand');

    // const savedCar =
    //     JSON.parse(
    //         localStorage.getItem('car_details')
    //     );
    
    const brands = [ "Hyundai", "NIO", "isuzu", "Volvo", "BYD", "Maruti", "Tata", "Honda", "Range Rover", "Mahindra", "Renault", "Volkswagen", "Skoda", "Ford", "Toyota", "Lexus", "Bentley", "Premier", "Chevrolet", "Genesis", "Citroën", "Tesla", "Fisker", "MG", "Kia", "Jeep", "Nissan", "Fiat", "Datsun", "BMW", "Mercedes", "Audi", "Force", "Nexa", "Jaguar", "Ferrari", "Porsche", "Land Rover", "Hindustan Ambassador", "Polestar", "Lucid Motors", "Rivian", "Xpeng Motors", "Rolls-Royce", "GMC", "Lamborghini" ];
        
    brandSelect.innerHTML =
        '<option value="">Select Brand</option>';

    brands.forEach(brand => {

        brandSelect.innerHTML +=
            `<option value="${brand}">${brand}</option>`;

    });
    brandSelect.addEventListener('change', function () {

        loadModels(this.value);

    });


        const car =
            getSavedCar();

            console.log("Saved Car:", car);

        if(!car){

            openCarPopup();

        }
        else{
              brandSelect.value =
                car.brand;

                loadModels(
                    car.brand,
                    car.model
                );
        }
         document.getElementById('continueVehicle').addEventListener('click',function(){
        console.log("Continue Clicked");
        const brand =

        document
        .getElementById(
        'popupCarBrand'
        )
        .value;

        const model =

        document
        .getElementById(
        'popupCarModel'
        )
        .value;

        if(!brand){

            alert(
            'Select Brand'
            );

            return;

        }

        if(!model){

            alert(
            'Select Model'
            );

            return;

        }
        console.log(brand, model);

        saveCar(
            brand,
            model
        );

        closeCarPopup();
        document.dispatchEvent(
    new CustomEvent(
        'vehicle:selected',
        {
            detail:{
                brand,
                model
            }
        }
    )
);

    });

    });



   
